import { Outlet } from "react-router-dom";
import styled from "styled-components";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { FormContainer } from "../components/RoundedContainer";
import { LandingLinks } from "../utils/NavLinks";

const StyledLayout = styled.div<{ $bg?: string }>`
    padding: var(--margin-page);
    padding-right: var(--margin-page-right);
    width: 100%;
    max-width: 100vw;
    min-width: 0;
    position: relative;
    background: ${(p) => p.$bg || "#fff"};
    overflow-x: hidden;
    box-sizing: border-box;
`;

const DashboardLayout = (props: { bg?: string }) => {
  const { bg } = props;
  return (
    <StyledLayout $bg={bg}>
      <Navbar links={LandingLinks} />

      <FormContainer
        $background="#fff"
        style={{
          paddingTop: "64px",
          borderColor: "var(--color-dashboard-box)",
          minHeight: "calc(100vh - 4*64px)",
        }}
        $spaceoutnavbar
      >
        <Outlet />
      </FormContainer>

      <Footer />
    </StyledLayout>
  );
};

export default DashboardLayout;
